import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
const sessionClient = axios.create({ baseURL: API, withCredentials: true });
let refreshPromise = null;
let sessionVersion = 0;
let csrfPromise = null;

function csrfToken(force = false) {
  if (force) csrfPromise = null;
  csrfPromise ||= axios.get(`${API}/auth/csrf`, { withCredentials: true })
    .then(({ data }) => data.csrf_token).catch((error) => { csrfPromise = null; throw error; });
  return csrfPromise;
}
const protectMutation = async (config) => {
  if (!["get", "head", "options"].includes((config.method || "get").toLowerCase())) {
    config.headers["X-CSRF-Token"] = await csrfToken();
  }
  return config;
};
client.interceptors.request.use(protectMutation);
sessionClient.interceptors.request.use(protectMutation);

export function invalidatePendingSession() { sessionVersion += 1; }
export async function settlePendingRefresh() {
  if (!refreshPromise) return;
  try { await refreshPromise; }
  catch (error) { console.debug("Previous session refresh ended", error.response?.status); }
}

client.interceptors.response.use((response) => response, async (error) => {
  const config = error.config;
  if (config && error.response?.status === 403 && error.response?.data?.detail === "CSRF token missing or invalid" && !config._csrfRetried) {
    config._csrfRetried = true;
    await csrfToken(true);
    return client(config);
  }
  if (error.response?.status !== 401 || !config || config._retried || config.skipRefresh ||
      ["/auth/login", "/auth/refresh", "/auth/logout"].includes(config.url)) throw error;
  const version = sessionVersion;
  config._retried = true;
  try {
    refreshPromise ||= sessionClient.post("/auth/refresh").finally(() => { refreshPromise = null; });
    await refreshPromise;
    if (version !== sessionVersion) throw error;
    return client(config);
  } catch (refreshError) {
    if (version === sessionVersion) window.dispatchEvent(new Event("atelier-session-expired"));
    throw refreshError;
  }
});

export function apiFormatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
